import { Select as MantineSelect, SelectProps } from '@mantine/core';

export type ISelectProps = SelectProps;

/** @registry Design-layer pass-through over Mantine Select; import this instead of @mantine/core Select outside src/design. Extend here when Select needs house behavior. */
export const Select = MantineSelect;
